import { FC, ReactNode } from 'react';

import { Box, Button, ButtonProps, rem } from '@bonusly/design-system';

interface ActionButtonProps extends ButtonProps {
	color: string;
	icon: ReactNode;
}

export const ActionButton: FC<ActionButtonProps> = ({ children, color, icon, ...rest }) => {
	const activeStyle = {
		bg: `${color}Alpha.100`,
		borderColor: 'transparent',
		color: color === 'green' ? 'green.700' : 'gray.700',
	};

	return (
		<Button
			bg="white"
			borderColor="gray.100"
			borderRadius="md"
			borderStyle="solid"
			borderWidth="1px"
			color="gray.900"
			data-testid="comment-button"
			fontSize="md"
			fontWeight="normal"
			height={{ base: rem(40) }}
			lineHeight={6}
			px={4}
			py={2}
			_active={activeStyle}
			_hover={activeStyle}
			{...rest}
		>
			{icon}
			<Box as="span" ml={2}>
				{children}
			</Box>
		</Button>
	);
};
